@if (isHomePage()) {
  <div
    class="special-offer-handler"
    [dwallClickableMedia]="['/main', 'home', 'special-offer']"
  ></div>
}

<app-happy-hours/>

<div [@homeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"/>
</div>
